module.exports = __webpack_public_path__ + "img/live-bg.7e6a50d.png";